export default __webpack_public_path__ + "static/shareimage_bagfacaden-df4c4376379f8c4c826de821f41229f6.png";